"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { CompanyTasks } from "@/features/companies/components/CompanyTasks";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";

export function CommunicationsTasksDisplay({ item }: TabContentProps<Communications>) {
  const communication = item;

  if (!communication.company_id) {
    return (
      <Card>
        <CardContent>
          <div className="text-center py-8 text-gray-500">
            <p>Link a company to this communication to view company follow-up tasks.</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return <CompanyTasks companyId={communication.company_id} />;
}
